export default {
  shelves: [],
  shelf: {}
}